<template>
<div class="chapter">
<div class="inner_page">
<h2 class="FmTitle" id="fm1"><a id="page_xii"></a><a id="page_xiii"></a><a href="#/Contents#rfm1">Foreword</a></h2>
<div class="quote">
<p class="noindentq"><span><span><i>To a woman in whom the state of true motherhood has awakened, all creatures are her children. This love, this motherhood, is Divine Love—and that is God.</i></span></span></p>
<p class="rightf"><span><span><i>—Amma</i></span></span></p>
</div>
<h3 class="h3">Turning Madness into Flowers</h3>
<p class="noindent"><span><span>It is my thought that the ugliness of war, of gratuitous violence in all its hideous forms, will cease very soon to appeal to even the most insulated of human beings. It will be seen by all for what it is: a threat to our well-being, to our survival as a species, and to our happiness. The brutal murder of our common mother, while we look on like frightened children, will become an unbearable visceral suffering that we will refuse to bear. We will abandon the way of the saw, the jackhammer and the drill. Of bombs, too.</span></span></p>
<p class="indent"><span><span><a id="page_xiv"></a>As religions and philosophies that espouse or excuse violence reveal their true poverty of hope for humankind, there will be a great awakening, already begun, about what is of value in life.</span></span></p>
<p class="indent"><span><span>We will turn our madness into flowers as a way of moving completely beyond all previous and current programming of how we must toe the familiar line of submission and fear, following orders given us by miserable souls who, somehow, have managed to almost completely control us. We will discover something wonderful: that the world really does not enjoy following the dictates of sociopaths and psychopaths, those who treat the earth, our mother, as if she is wrong, and must be constantly corrected, in as sadistic and domineering a way as that of a drunken husband who kills his wife.</span></span></p>
<p class="indent"><span><span>The world—the animals, including us humans—wants to be engaged in something entirely other, seeing, and delighting in, the stark wonder of where we are: This place. This gift. This paradise.</span></span></p>
<p class="indent"><span><span>We want to follow joy.</span></span></p>
<p class="indent"><span><span>And we shall.</span></span></p>
<p class="indent"><span><span><a id="page_xv"></a>The madness, of course, for each one of us, will have to be sorted out.<sup><span href="#/Backmatter001#en1" id="ren1" title="Link target outside of Sample">1</span></sup></span></span></p>
<p class="rightr"><span><span><i>—Alice Walker</i></span></span></p>
<p class="rightra"><span><span><i>August 2012</i></span></span></p>
<p class="rightra"><span><span><i><a href="http://www.AliceWalkersGarden.com" target="_blank">www.AliceWalkersGarden.com</a></i></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter001.vue?5145e8ec